module.exports = __webpack_public_path__ + "static/img/2_2_2.4d4ec1c6.jpg";